<template>
  <div class="main-calculated">
    <AdvancedCalc v-if="haveAdvancedCalcs == true" :next="next" />
    <div v-else>
      <div class="container-calculated">
        <div>
          <label>{{ $t('criar-tags') }}</label>
          <b-tabs class="tab-create-tags" card>
            <b-tab :title="$t('gemeo-digital')" class="set-variable mapping-tab" @click="updateTab(3)" active>
              <label for="ind-calcType">{{ $t('nome-do-coletor') }}</label>
              <b-form-input :id="`tag-name`" v-model="mappingTag" :placeholder="$t('ex-moagemonline')"
                @keyup="updateMappingName">
              </b-form-input>
              <label id="tag-mapping-selected" class="mt-2">
                {{ $t('tag-selecionado') }}
                <strong :class="{ 'selectable': $t('not-selected') != mappingValue }" @click="filterMappingByClick">
                  {{ this.mappingValue }}
                </strong>
              </label>
              <div class="field-filter-mapping">
                <label for="filter-mapping">Filtrar: </label>
                <b-form-input :id="`filter-mapping`" size="sm" v-model="filterMapping"
                  :placeholder="$t('procurar-mapeamento')">
                </b-form-input>
              </div>

              <b-table class="table-mapping" striped hover small Fixed sticky-header selectable select-mode="single"
                v-if="showTable" @row-clicked="mappingSelected" :items="mappings" :fields="mappingFields">
              </b-table>
              <label class="table-mapping-info">{{ mappings.length }} - {{ allMappings.length }}</label>
            </b-tab>

            <b-tab id="select-plan" :title="$t('plano-de-safra-0')" class="set-variable" @click="updateTab(4)">
              <label for="ind-calcType" class="mt-1">{{ $t('item-do-plano-de-safra-mensal') }}</label>
              <b-form-select id="ind-calcType" v-model="productionPlanSelected" @change="planSelected"
                :options="productionsPlans">
              </b-form-select>
              <label class="mt-2" for="ind-calcType">{{ $t('nome-do-tag') }}
                <strong>{{ productionPlanTag }}</strong></label>
              <div>
                <label class="mt-1">{{ $t('valor') + ":" }} <strong> {{ productionPlanSelected ?
                  productionPlanSelected.value : 0 }} </strong></label>
              </div>
              <div>
                <label class="mt-1">{{ $t('data-referencia') }} <strong> {{ productionPlanSelected ?
                  productionPlanSelected.dateTime : "-" }} </strong></label>
              </div>
              <div>
                <label class="mt-1">{{ $t('ultima-atualizacao') }}<strong> {{ productionPlanSelected ?
                  productionPlanSelected.lastUpdate : "-" }} </strong></label>
              </div>
            </b-tab>

            <b-tab id="select-const" :title="$t('constante')" class="set-variable" @click="updateTab(1)">
              <label for="ind-Name">Nome da constante</label> <input v-if="nameConstant == 'selftest'" id="testing-drop"
                @change="testingDragingDrop" v-model="testingDraging" type="text" />
              <b-form-input :id="`tag-const`" v-model="nameConstant" :placeholder="$t('ex-fatordecorrecao')"
                maxlength="50" @keyup="updateCosntant">
              </b-form-input>
              <label for="number-const">{{ $t('valor-da-constante') }}</label>
              <b-form-input :id="`number-const`" type="number" v-model="valueConstante" maxlength="50" min="0"
                placeholder="Ex: 15555.454">
              </b-form-input>
            </b-tab>
            <b-tab id="select-indicator" title="Indicador" class="set-variable" @click="updateTab(2)">
              <label for="ind-Name">{{ $t('procure-um-indicador') }}</label>
              <b-form-select id="tag-indicator" v-model="indicatorSelected" size="sm" :options="indicators"
                @change="updateNameIndicator">
              </b-form-select>
              <label class="mt-2">Tag: <strong>{{ this.indicatorValue }}</strong></label>
            </b-tab>
          </b-tabs>
          <div class="collector-buttons">
            <b-icon id="clean-form" class="icon-button-pentagro mr-2 mt-1" :title="$t('limpar-formulario')" icon="eraser"
              @click="cleanForm"></b-icon>
            <b-icon id="add-tag" class="icon-button-pentagro mr-2 mt-1" title="Adicionar Tag" icon="plus-circle"
              @click="addTag"></b-icon>
          </div>
        </div>

        <div class="calculate-collected">
          <label>{{ $t('tags-criados') }}</label>
          <div v-if="!reloading" class="tags-list">
            <label v-for="tag, index in tagsCreated" :id="'tag_' + tag.name" title="Clique para visualizar"
              class="tag-item" :key="index" @click="updateForm(tag)" draggable="true" @dragstart="drag">
              {{ tag.name }} <span v-if="!tag.used" class="remove-tag" :title="$t('remover') + ' ' + tag.name"
                @click="askRemoveTag(tag)">X</span>
            </label>
          </div>
          <div v-else class="tags-list">
          </div>
          <div>
            <label class="mt-2" for="">{{ $t('operadores-aritimeticos') }}</label>
            <div class="arithmetic-operators">
              <label v-for="tag, index in tagsOperations" :key="index" :id="`operation-${index}`"
                :title="$t('arraste-para-efetuar-o-calculo')" draggable="true" @dragstart="drag">
                {{ tag }}
              </label>
            </div>
          </div>
          <label class="mt-2">{{ $t('area-de-aplicacao') }}<strong class="ml-1">{{ typeCalculate }}</strong></label>
          <div class="space-calcaulation">
            <b-tabs pills card vertical end class="tab-calculations-ref">
              <b-tab :disabled="disableOnline || viwsAgregations.get('ON')" title="Online" @click="setTypeCalculte(0)"
                active>
                <div id="calculation-area-online" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('LD')" title="Dia" @click="setTypeCalculte(1)">
                <div id="calculation-area-day" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CW')" title="Semana" @click="setTypeCalculte(2)">
                <div id="calculation-area-week" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CM')" title="Mês" @click="setTypeCalculte(3)">
                <div id="calculation-area-month" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CY')" title="Safra" @click="setTypeCalculte(4)">
                <div id="calculation-area-harvest" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
            </b-tabs>
          </div>
          <div class="collector-buttons">
            <div>
              <b-icon id="clear-calc" class="icon-button-pentagro mr-2 mt-1" :title="$t('limpar-calculo')" icon="eraser"
                @click="cleanCalculate"></b-icon>
              <b-icon id="back-space" class="icon-button-pentagro mr-2 mt-1" :title="$t('apagar-ultimo')"
                icon="arrow-return-left" @click="backspaceCalculate"></b-icon>
            </div>
            <b-icon id="next-step" class="icon-button-pentagro mr-2 mt-1" :title="$t('proximo')" icon="arrow-right"
              @click="next"></b-icon>
          </div>
        </div>
      </div>
      <b-modal id="confirmRemoveTag" ok-variant=danger :title="$t('atencao')" :ok-title="$t('yes')"
        :cancel-title="$t('no')" @ok="removeTag">{{ $t('confirma-remover-o-tag') }} [{{ transientValue.name }}] ?
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { defaultSuccess,showError } from '../../../../../global';
import IndicatorDataSource from "../../utilities/IndicatorDataSource"
import AdvancedCalc from '../../utilities/AdvancedCalc.vue';
import Mediator from '../../utilities/Mediator'
import MediatorCalculated from './MediatorCalculated'
import Indicator from '../../utilities/Indicator';

export default {
  name: "Manage-Calculated-Reference",
  components: { AdvancedCalc },
  data() {
    return {
      step: "step-3",
      nextStep: "step-4",

      testingDraging: "",
      tagsCreated: [],
      tagsOperations: ["(", ")", "+", "-", "*", "/"],
      tabSelected: 3,
      mappingTag: "",
      nameConstant: "",
      valueConstante: 0,
      transientValue: {},
      disableOnline: false,
      reloading: false,

      mappingFields: [{ key: "text", label: "Mapeamento" }, { key: "value", label: "Valor" }],
      mappings: [],
      allMappings: [],
      mappingValue: this.$t('not-selected'),
      filterMapping: "",
      showTable: true,

      productionsPlans: [],
      productionPlanSelected: null,
      productionPlanTag: "-",

      indicators: [],
      indicatorValue: "",
      indicatorSelected: null,
      indexCalcType: 0,
      typeCalculate: "Online",
      typesCalculate: ["Online", "Dia", "Semana", "Mês", "Safra"],
      qtdShown: 200,
      showError: showError,
      viwsAgregations: new Map(),
      haveAdvancedCalcs: false,
    }
  },

  computed: mapState(["user"]),

  watch: {
    filterMapping(value) {
      let partys = value.split("*")
      this.mappings = this.allMappings
        .filter(m => {
          let returnValue = false;
          for (var element of partys) {
            returnValue = JSON.stringify(m).toUpperCase().includes(element.toUpperCase())
            if (!returnValue) break;
          }
          return returnValue
        }).slice(0, this.qtdShown)
    },

    tagsCreated() {
      MediatorCalculated.notify(null, "load-calc")
    },
  },

  methods: {
    testingDragingDrop() {
      let value = this.testingDraging;
      if (!this.testingDraging) return
      this.drop({
        preventDefault() { },
        dataTransfer: {
          getData() {
            return value
          }
        }
      })
    },

    filterMappingByClick() {
      if (this.mappingValue.includes(this.$t('not-selected'))) return;

      if (!this.filterMapping)
        this.filterMapping = this.mappingValue.split(":")[0].trim();
      else
        this.filterMapping = "";
    },

    allowDrop(ev) {
      ev.preventDefault();
    },

    drag(ev) {
      ev.dataTransfer.setData("tag", ev.target.id);
    },

    drop(ev) {
      ev.preventDefault();
      var key = ev.dataTransfer.getData("tag").replace("tag_", "");
      if (!key) return
      MediatorCalculated.notify(key, "insert-element")
    },

    mappingSelected(value) {
      if (value)
        this.mappingValue = value.text + " : " + value.value
      else
        this.mappingValue = ""
    },

    planSelected() {
      this.productionPlanTag = "Plan-" + this.productionPlanSelected.planTag
    },


    updateMappingName() {
      this.mappingTag = this.adjustTag(this.mappingTag)
    },

    updateCosntant() {
      this.nameConstant = this.adjustTag(this.nameConstant)
    },

    updateProductionPlanName() {
      this.productionPlanTag = this.adjustTag(this.productionPlanTag)
    },

    updateNameIndicator() {
      let name = this.indicators.find(i => i.value == this.indicatorSelected)
      if (name)
        this.indicatorValue = this.adjustTag(name.text).replace(/\//g, "-")
          .replace(/[^a-z0-9/]/gi, "")
          .replace(/(^[0-9])/, "_$1");
    },

    adjustTag(value) {
      return value.replace(/\//g, "-")
        .replace(/[^a-z0-9_]/gi, "")
        .replace(/(^[0-9])/, "_$1")
        .substring(0, 45);
    },

    cleanCalculate() {
      MediatorCalculated.notify(null, "clean-calculate")
    },

    backspaceCalculate() {
      MediatorCalculated.notify(null, "backspace-calculate")
    },

    addTag() {
      try {
        this.validForm()
      }
      catch (e) {
        showError(e)
        return
      }

      let tag = {}
      console.log('this.tabSelected', this.tabSelected)
      if (this.tabSelected == 3) {
        tag = new IndicatorDataSource({
          key: this.mappingValue.split(':')[0].trim(),
          name: this.adjustTag(this.mappingTag),
          variables: [this.mappingValue],
          type: this.tabSelected,
          used: false
        })
      }
      else if (this.tabSelected == 4) {
        tag = new IndicatorDataSource({
          key: this.productionPlanTag,
          name: this.productionPlanTag,
          variables: [this.productionPlanSelected.planTag],
          type: this.tabSelected,
          used: false
        })
      }
      else if (this.tabSelected == 1) {
        tag = new IndicatorDataSource({
          key: this.adjustTag(this.nameConstant),
          name: this.adjustTag(this.nameConstant),
          variables: [this.valueConstante],
          type: this.tabSelected,
          used: false
        })
      }
      else if (this.tabSelected == 2) {

        tag = new IndicatorDataSource({
          key: this.indicatorSelected,
          name: this.indicatorValue,
          variables: [this.indicatorSelected],
          type: this.tabSelected,
          used: false
        })
      }

      this.tagsCreated.push(tag)
      Mediator.notify(this, "update-step-3")
      this.cleanForm()
    },

    askRemoveTag(tag) {
      this.transientValue = tag
      this.$bvModal.show("confirmRemoveTag");
    },

    removeTag() {
      let index = -1;
      this.tagsCreated.forEach((tag, i) => {
        if (tag.name == this.transientValue.name)
          index = i
      })
      if (index > -1)
        this.tagsCreated.splice(index, 1)
    },

    validForm() {
      if (!this.mappingTag && this.tabSelected == 3)
        throw this.$t('o-campo-nome-do-tag-nao-pode-ser-em-branco')

      if (!this.productionPlanTag && this.tabSelected == 4)
        throw this.$t('selecione-um-item-do-plano-de-safra')

      if (!this.nameConstant && this.tabSelected == 1)
        throw this.$t('o-campo-nome-da-constante-nao-pode-ser-em-branco')

      let tagFound = this.tagsCreated.find(t =>
        t.name == this.mappingTag && this.tabSelected == 3 ||
        t.name == this.productionPlanTag && this.tabSelected == 4 ||
        t.name == this.nameConstant && this.tabSelected == 1 ||
        t.name == this.indicatorName && this.tabSelected == 2
      )
      if (tagFound)
        throw this.$t('variavel-tagfound-name-ja-foi-alocada-entre-com-um-nome-de-variavel-diferente', [tagFound.name])
    },

    cleanForm() {
      this.mappingTag = "";
      this.nameConstant = "";
      this.valueConstante = 0;
      this.indicatorSelected = null
      this.indicatorValue = ""
      this.productionPlanSelected = null
      this.productionPlanTag = "-"
      this.mappingValue = ""
      this.filterMapping = ""
    },

    updateTab(index) {
      this.cleanForm();
      this.tabSelected = index
    },

    updateForm(tag) {
      MediatorCalculated.notify(tag, "update-form")
    },

    setTypeCalculte(typeCalculate) {
      this.indexCalcType = typeCalculate;
      this.typeCalculate = this.typesCalculate[typeCalculate]
    },

    loadSintaxes() {
      defaultSuccess("Construindo sintaxe do previsto.")
      this.allMappings = Object.keys(Mediator.data.xmlMapping).map(key => {
        return { text: key, value: Mediator.data.xmlMapping[key] }
      })
      this.mappings = this.allMappings.slice(0, this.qtdShown)

      this.productionsPlans = Mediator.data.productionPlanItens.map(plan =>
      ({
        value: plan,
        text: plan.planName
      }))
      this.productionsPlans.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
      this.productionsPlans.splice(0, 0, { value: null, text: this.$t('selecione-um-item') })

      this.indicators = Mediator.data.indicators.map(i => ({ value: `${i.id}-${i.productionUnitId}-${i.system}`, text: i.indicatorName }));
      this.indicators.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
      this.indicators.splice(0, 0, { value: null, text: this.$t('selecione-um-indicador') })
    },

    next() {
      Mediator.notify(this.ind, "update-indicator")
      Mediator.notify(this, "select-step-by-form")
    },

    loadTagsCreated(indicator) {
      let prevsFound = indicator.indPrevList.filter(ind => ind.name && ind.name != "NOTFOUND" && ind.name != "");
    
      let emptyIndicator = new Indicator();

      this.tagsCreated = prevsFound
      MediatorCalculated.tagsCreated = prevsFound     

      if(prevsFound.length == 0 || Mediator.mainScreen.showPrevError){
        if(Mediator.mainScreen.showPrevError){
          MediatorCalculated.targetOnline = emptyIndicator.targetOnline;
          MediatorCalculated.targetDay = emptyIndicator.targetDay;
          MediatorCalculated.targetWeek = emptyIndicator.targetWeek;
          MediatorCalculated.targetMonth = emptyIndicator.targetMonth;
          MediatorCalculated.targetHarvest = emptyIndicator.targetHarvest;

          showError("Falha ao construir sintaxes do previsto.")
          return;
        }

        this.tagsCreated = emptyIndicator.indPrevList
        MediatorCalculated.tagsCreated = emptyIndicator.indPrevList
        MediatorCalculated.targetOnline = emptyIndicator.targetOnline;
        MediatorCalculated.targetDay = emptyIndicator.targetDay;
        MediatorCalculated.targetWeek = emptyIndicator.targetWeek;
        MediatorCalculated.targetMonth = emptyIndicator.targetMonth;
        MediatorCalculated.targetHarvest = emptyIndicator.targetHarvest;

        showError("Falha ao construir sintaxes do previsto.")
        return;
      }

      MediatorCalculated.targetOnline = indicator.targetOnline != "NOTFOUND" ? indicator.targetOnline : emptyIndicator.targetOnline;
      MediatorCalculated.targetDay = indicator.targetDay != "NOTFOUND" ? indicator.targetDay : emptyIndicator.targetDay;
      MediatorCalculated.targetWeek = indicator.targetWeek != "NOTFOUND" ? indicator.targetWeek : emptyIndicator.targetWeek;
      MediatorCalculated.targetMonth = indicator.targetMonth != "NOTFOUND" ? indicator.targetMonth : emptyIndicator.targetMonth;
      MediatorCalculated.targetHarvest = indicator.targetHarvest != "NOTFOUND" ? indicator.targetHarvest : emptyIndicator.targetHarvest;

      if (indicator.calcType == "diario" || indicator.calcType == "sazonal") {
        this.disableOnline = true
        this.indexCalcType = 1
        this.typeCalculate = this.typesCalculate[1]
      } else {
        this.disableOnline = false
        this.indexCalcType = 0
        this.typeCalculate = this.typesCalculate[0]
      }

      defaultSuccess("Sintaxe do previsto construída com sucesso.")
    },

    update() {
      Mediator.notify(this, "update-step-3")
    },

    setViewsAgregations() {
      if (this.user.Permissions.dashboard01) {
        this.viwsAgregations.set(this.user.Permissions.dashboard01.parameter, !this.user.Permissions.dashboard01.permission)
      }
      if (this.user.Permissions.dashboard02) {
        this.viwsAgregations.set(this.user.Permissions.dashboard02.parameter, !this.user.Permissions.dashboard02.permission)
      }
      if (this.user.Permissions.dashboard03) {
        this.viwsAgregations.set(this.user.Permissions.dashboard03.parameter, !this.user.Permissions.dashboard03.permission)
      }
      if (this.user.Permissions.dashboard04) {
        this.viwsAgregations.set(this.user.Permissions.dashboard04.parameter, !this.user.Permissions.dashboard04.permission)
      }
      if (this.user.Permissions.dashboard05) {
        this.viwsAgregations.set(this.user.Permissions.dashboard05.parameter, !this.user.Permissions.dashboard05.permission)
      }
    },
  },

  mounted() {
    this.haveAdvancedCalcs = Mediator.checkAdvancedCalcs(Mediator.indicator, "target");

    this.loadSintaxes()
    Mediator.notify(this, "init-step")
    MediatorCalculated.notify(this, "init-step")
    this.setViewsAgregations()
  }
}
</script>

<style scoped>
h5 {
  text-align: center;
}

.main-calculated {
  display: flex;
  justify-self: center;
  flex-direction: column;
  justify-items: center;
  width: 100%;
}

.container-calculated {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 8px;
}

.calculate-collected {
  border-left: 1px solid #0003;
  padding-left: 8px;
}

.container-collected,
.set-variable {
  min-height: 53vh;
}

.tab-calculations-ref {
  min-height: 23.6vh;
  flex-wrap: nowrap;
}

.table-mapping {
  max-height: 25.2vh;
}

.space-calcaulation {
  max-height: 35.2vh;
}

.tags-list {
  background-color: #fafafa;
  box-shadow: 0 0 3px #0001;
  border-radius: 4px;
  min-height: 20vh;
  padding: 2px;
}

.tag-calc,
.operation-tag,
.arithmetic-operators>label,
.tag-item {
  background-color: #00000010;
  padding: 2px 6px;
  border-radius: 4px;
  margin: 2px;
  cursor: pointer;
  border: 1px solid #0001;
  color: #555;
}

.arithmetic-operators>label:hover,
.tag-item:hover {
  background-color: #00a39f4d;
}

.arithmetic-operators>label:hover {
  background-color: #ff5b0030;
}

.arithmetic-operators>label {
  min-width: 24px;
  text-align: center;
}

.remove-tag {
  color: #000;
  font-weight: 500;
}

.remove-tag:hover {
  color: #f00;
  font-weight: 500;
}

.collector-buttons {
  display: flex;
  justify-content: space-between;
}

.field-filter-mapping {
  display: flex;
}

.field-filter-mapping>input {
  margin-left: 8px;
  padding: 4px 2px;
  height: 25px;
}

.table-mapping {
  margin-bottom: 0px;
  border-radius: 4px;
  box-shadow: 0 0 2px #0004;
}

.mapping-tab {
  padding-bottom: 0px;
}

.table-mapping-info {
  width: 100%;
  text-align: end;
  margin-bottom: 0;
}

.button-pentagro {
  background-color: #00A39F;
  border-color: #00A39F;
}

@media (min-height: 770px) {

  .container-calculated,
  .set-variable {
    min-height: 63vh;
  }

  .table-mapping {
    max-height: 43vh;
  }
}
</style>

<style>
/* INICIO - AREA DE CALCULOS */

.tab-calculations-ref ul {
  padding: 0;
  background-color: #00000001;
}

.tab-calculations-ref li {
  width: 72px;
  padding: 0;
}

.container-calculated>div>div>div>ul.card-header {
  padding: 12px 16px;
}

.container-calculated a,
.tab-calculations-ref a {
  padding: 3.7px 4px;
  color: #0009 !important;
  background-color: #00000010 !important;
  font-weight: 500;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.container-calculated a.active,
.tab-calculations-ref a.active {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  background-color: #fafafa !important;
  color: #ff5f00 !important;
  text-decoration: underline !important;
  ;
}

.tab-calculations-ref a.nav-link {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.container-calculated a.nav-link:hover,
.tab-calculations-ref a.nav-link:hover {
  background-color: #fafafa !important;
}

.tab-create-tags a.active {
  background-color: #fff !important;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}


.tab-calculations-ref>div>div {
  padding: 0;
}

.tab-calculations-ref>div>div>div {
  min-height: 22vh;
  max-width: 519px;
  overflow-x: auto;
}


.calculation-area {
  background-color: #fafafa;
  border-radius: 4px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  height: 100%;
  width: 100%;
}

.selectable {
  cursor: pointer;
}

@media (min-height: 770px) {
  .tab-calculations-ref>div>div>div {
    min-height: 32.5vh !important;
    max-width: 672.5px;
  }

  .tab-calculations-ref a.nav-link {
    height: 6.5vh;
    padding: 15px 0 0 9px;
  }

  .tags-list {
    min-height: 23vh !important;
  }

  .space-calcaulation {
    min-height: 32.4vh;
  }
}

/* FIM - AREA DE CALCULOS */
</style>